export default {
  layouts: {
    auth: {
      becomePartner: 'Hamkorlik',
      support: "Savollaringiz bormi? Bizga qo'ng'iroq qiling:",
    },
  },
};
